import React from 'react'
import { useForm } from 'react-final-form'

import * as headCertificateTypes from './headCertificateTypes'

const useCertificate = (props: headCertificateTypes.UseCertificateType) => {
    const form = useForm()
    const [textRemaining, setTextRemaining] = React.useState<{ TH: number; EN: number }>({ TH: 500, EN: 500 })

    React.useEffect(() => {
        const formVal = form.getState().values
        const textRemainingTH = 500 - (formVal?.projectNameTH?.length ?? 0)
        const textRemainingEN = 500 - (formVal?.projectNameEN?.length ?? 0)
        setTextRemaining({ TH: textRemainingTH, EN: textRemainingEN })
    }, [form.getState().values.projectNameTH ?? null, form.getState().values.projectNameEN ?? null])

    const handleChangTextField = (val: string, language: string) => {
        let objText = textRemaining
        if (language === 'TH') {
            objText = { TH: 500 - val.length, EN: textRemaining.EN }
        } else {
            objText = { TH: textRemaining.TH, EN: 500 - val.length }
            setTextRemaining({ TH: 500 - val.length, EN: textRemaining.EN })
        }
    }

    return {
        onChangTextField: handleChangTextField,
        textRemaining,
    }
}

export default useCertificate
